/**
 * Buffer audio
 *
 * @param {Float32Array} inputBuffer
 * @param {Float32Array} outputBuffer
 * @returns {Float32Array} updated output buffer
 */
export default function bufferAudio(inputBuffer, outputBuffer) {
  if (outputBuffer) {
    const buffer = new Float32Array(outputBuffer.length + inputBuffer.length);
    buffer.set(outputBuffer);
    buffer.set(inputBuffer, outputBuffer.length);
    return buffer;
  }

  return new Float32Array(0);
}
